export default "__VITE_ASSET__BeddJx9V__"